const actions = {
    setWheelIncrement: (context, val) => {
        context.commit('INCREMENT_WHEEL', val)
    },
    setCurrentScroll: (context, val) => {
        context.commit('CURRENT_SCROLL', val)
    },
    setSmoothState: (context, val) => {
        context.commit('IS_SMOOTH', val)
    },
    setLimitScroll: (context, val) => {
        context.commit('LIMIT_SCROLL', val)
    },
    setScrollTriggerInstance: (context, val) => {
        context.commit('SCROLL_TRIGGER_INSTANCE', val)
    },
    setScrollTriggerProgress: (context, val) => {
        context.commit('SCROLL_TRIGGER_PROGRESS', val)
    }
};

export default actions;